import {
  MaintainanceError,
  UnauthorizedError,
} from '@/core/types/errors/http-error'
import { envService } from '../env'
import { HttpClient } from './http-client'

const createHttpClient = () => {
  const httpClient = new HttpClient(envService.get('BASE_URL'), {
    insecureHTTPParser: true,
  })

  httpClient.addResponseInterceptor(
    response => response,
    err => {
      if (err.status === 503 || err.response?.status === 503) {
        throw new MaintainanceError()
      }
      if (err.status === 401 || err.response?.status === 401) {
        throw new UnauthorizedError()
      }

      throw err
    },
  )

  return httpClient
}

export const httpClient = createHttpClient()
export { type IHttpClient } from './http-client'
